import type { RouteRecordRaw } from 'vue-router'

import { DEFAULT_LAYOUT } from '@/router/constant'
import { UserDetailPageModeEnum } from '@/enums'

const userInfo: RouteRecordRaw = {
  path: '/userInfo',
  name: 'userInfo',
  component: DEFAULT_LAYOUT,
  redirect: '/userInfo/userInfoIndex',

  children: [
    {
      path: 'userInfoIndex',
      name: 'UserInfoIndex',
      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/userInfo/userInfoIndex.vue'),
      meta: { title: '利用者情報一覧', requiresAuth: true },
    },

    {
      path: 'reference',
      name: UserDetailPageModeEnum.REFERENCE,
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/userInfo/user-info-reference/UserInfoReference.vue'
        ),
      meta: { title: '利用者情報', requiresAuth: true },
    },

    {
      path: 'edition',
      name: UserDetailPageModeEnum.EDITION,
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/userInfo/user-info-reference/UserInfoReference.vue'
        ),
      meta: { title: '利用者情報', requiresAuth: true },
    },

    {
      path: 'addition',
      name: UserDetailPageModeEnum.ADDTION,
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/userInfo/user-info-reference/UserInfoReference.vue'
        ),
      meta: { title: '利用者追加', requiresAuth: true },
    },

    {
      path: 'referenceGuest',
      name: UserDetailPageModeEnum.REFERENCE_GUEST,
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/userInfo/user-info-reference/UserInfoReferenceGuest.vue'
        ),
      meta: { title: '利用者情報', requiresAuth: true },
    },

    {
      path: 'editionGuest',
      name: UserDetailPageModeEnum.EDITION_GUEST,
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/userInfo/user-info-reference/UserInfoReferenceGuest.vue'
        ),
      meta: { title: '利用者情報', requiresAuth: true },
    },
  ],
}

export default userInfo
